/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("cs", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Produkt ${i.products} již není k dispozici`;
	if (nbDeletedPlural == "other") return `Produkty ${i.products} již nejsou k dispozici`;
	return "cart_errors.deleted";
};

const da_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("da", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Produktet ${i.products} er ikke længere tilgængeligt`;
	if (nbDeletedPlural == "other") return `Produkter ${i.products} er ikke længere tilgængelige`;
	return "cart_errors.deleted";
};

const de_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("de", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Das Produkt ${i.products} ist nicht mehr verfügbar`;
	if (nbDeletedPlural == "other") return `Die Produkte ${i.products} sind nicht mehr verfügbar`;
	return "cart_errors.deleted";
};

const en_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("en", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `The product ${i.products} is no longer available`;
	if (nbDeletedPlural == "other") return `The products ${i.products} are no longer available`;
	return "cart_errors.deleted";
};

const es_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("es", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `El producto ${i.products} ya no está disponible`;
	if (nbDeletedPlural == "other") return `Los productos ${i.products} ya no están disponibles`;
	return "cart_errors.deleted";
};

const fr_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("fr", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Le produit ${i.products} n'est plus disponible`;
	if (nbDeletedPlural == "other") return `Les produits ${i.products} ne sont plus disponible`;
	return "cart_errors.deleted";
};

const hu_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("hu", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `A termék ${i.products} már nem elérhető`;
	if (nbDeletedPlural == "other") return `A termékek ${i.products} már nem érhetők el`;
	return "cart_errors.deleted";
};

const it_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("it", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Il prodotto ${i.products} non è più disponibile`;
	if (nbDeletedPlural == "other") return `I prodotti ${i.products} non sono più disponibili`;
	return "cart_errors.deleted";
};

const nl_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("nl", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Het product ${i.products} is niet meer beschikbaar`;
	if (nbDeletedPlural == "other") return `De producten ${i.products} zijn niet meer beschikbaar`;
	return "cart_errors.deleted";
};

const pl_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("pl", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Produkt ${i.products} nie jest już dostępny`;
	if (nbDeletedPlural == "other") return `Produkty ${i.products} nie są już dostępne`;
	return "cart_errors.deleted";
};

const pt_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("pt", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `O produto ${i.products} não está mais disponível`;
	if (nbDeletedPlural == "other") return `Os produtos ${i.products} não estão mais disponíveis`;
	return "cart_errors.deleted";
};

const sv_cart_errors_deleted = /** @type {(inputs: { nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }) => string} */ (i) => {const nbDeletedPlural = registry.plural("sv", i.nbDeleted, {});
	if (nbDeletedPlural == "one") return `Produkten ${i.products} är inte längre tillgänglig`;
	if (nbDeletedPlural == "other") return `Produkter ${i.products} är inte längre tillgängliga`;
	return "cart_errors.deleted";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ nbDeleted: NonNullable<unknown>, products: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cart_errors_deleted = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_errors_deleted(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_errors_deleted", locale)
	if (locale === "cs") return cs_cart_errors_deleted(inputs)
	if (locale === "da") return da_cart_errors_deleted(inputs)
	if (locale === "de") return de_cart_errors_deleted(inputs)
	if (locale === "en") return en_cart_errors_deleted(inputs)
	if (locale === "es") return es_cart_errors_deleted(inputs)
	if (locale === "fr") return fr_cart_errors_deleted(inputs)
	if (locale === "hu") return hu_cart_errors_deleted(inputs)
	if (locale === "it") return it_cart_errors_deleted(inputs)
	if (locale === "nl") return nl_cart_errors_deleted(inputs)
	if (locale === "pl") return pl_cart_errors_deleted(inputs)
	if (locale === "pt") return pt_cart_errors_deleted(inputs)
	return sv_cart_errors_deleted(inputs)
};
export { cart_errors_deleted as "cart_errors.deleted" }